// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-sidebar {
  width: 220px;
  background: #222e3c;
  color: #fff;
  min-height: 100vh;
  box-shadow: 2px 0 8px rgba(0,0,0,0.04);
  padding-top: 32px;
}

.sidebar-title {
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 32px;
}

.dashboard-sidebar nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dashboard-sidebar nav li {
  padding: 16px 32px;
  font-size: 16px;
  cursor: pointer;
  background: none;
  border: none;
  color: #fff;
  transition: background 0.2s;
}

.dashboard-sidebar nav li.active,
.dashboard-sidebar nav li:hover {
  background: #1a2230;
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardSidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":[".dashboard-sidebar {\n  width: 220px;\n  background: #222e3c;\n  color: #fff;\n  min-height: 100vh;\n  box-shadow: 2px 0 8px rgba(0,0,0,0.04);\n  padding-top: 32px;\n}\n\n.sidebar-title {\n  font-size: 22px;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.dashboard-sidebar nav ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.dashboard-sidebar nav li {\n  padding: 16px 32px;\n  font-size: 16px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  color: #fff;\n  transition: background 0.2s;\n}\n\n.dashboard-sidebar nav li.active,\n.dashboard-sidebar nav li:hover {\n  background: #1a2230;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
